<script setup>
import {envs} from "@/main/envs";
import Step1 from "../../img/MacOS/1.png";
import Step2 from "../../img/MacOS/2.png";
import Step3 from "../../img/MacOS/5.png";
import Step4 from "../../img/MacOS/6.png";

const steps = [
  Step1,
  Step2,
  Step3,
  Step4,
];

</script>

<template>
  <el-carousel :interval="5000" :autoplay="false" indicator-position="none">
    <el-carousel-item>
      <div class="flex flex-vertical fit">
        <div class="flex image">
          <el-image :src="Step1" fit="fit" :preview-src-list="steps"/>
        </div>
        <div class="flex">1、下载完成后，找到刚才下载的后缀名为.dmg的文件。双击该安装文件开始安装。</div>
      </div>
    </el-carousel-item>
    <el-carousel-item>
      <div class="flex flex-vertical fit">
        <div class="flex image">
          <el-image :src="Step2" fit="fit" :preview-src-list="steps"/>
        </div>
        <div class="flex">2、Mac OS会出现安装提示。请将左边安装软件图标拖入右边文件夹图标中，系统自动开始安装。</div>
      </div>
    </el-carousel-item>
    <el-carousel-item>
      <div class="flex flex-vertical fit">
        <div class="flex image">
          <el-image :src="Step3" fit="fit" :preview-src-list="steps"/>
        </div>
        <div class="flex">3、安装成功后，可以在应用程序找到《{{envs.productName}}》软件启动图标</div>
      </div>
    </el-carousel-item>
    <el-carousel-item>
      <div class="flex flex-vertical fit">
        <div class="flex image">
          <el-image :src="Step4" fit="fit" :preview-src-list="steps"/>
        </div>
        <div class="flex">双击打开软件。</div>
      </div>
    </el-carousel-item>
  </el-carousel>
</template>

<style scoped>
.flex.fit {
  justify-content: center;
  overflow: auto;
}
.image {
  justify-content: center;
  overflow: auto;
}
</style>
